import Copy from './view';
export default Copy;
